<em-main>
  @if (isServerSidePaginationEnabled$ | async) {
    <em-new-table-section></em-new-table-section>
  } @else {
    <em-old-table-section></em-old-table-section>
  }
</em-main>
